import React from "react"

import MainMenu_MoreButton from "../../../menu/menu-items/menu-more"

type Props = {
    hideHint        : callback
    onTogglePopover : {(showPopover:boolean):void}
}

const debug = false
// const debug = "navigation_hintButtonSectionView"

export default function navigation_hintButtonSectionView(moreOptions: Option[], props:Props) {

    return <MainMenu_MoreButton className       = "button flex-row-center-center m-r-5"
                                menuOptions     = {moreOptions}
                                onTogglePopover = {props.onTogglePopover}/>

}
